import React, { ErrorInfo } from 'react';

import { getNewRelicAgent, AgentInstance } from '../../newrelic';
import { WidgetErrors } from '../../shared/constants';

class ErrorBoundary extends React.Component<any, any> {
	private agent: AgentInstance | null;

	constructor(props: any) {
		super(props);
		this.state = { hasError: false };
		this.agent = getNewRelicAgent();
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error: Error, info: ErrorInfo) {
		this.agent?.noticeError(error.name || WidgetErrors.boundaryError, {
			component: 'ErrorBoundary',
			message: error.message,
			error,
			info,
		});
	}

	render() {
		const { hasError } = this.state;
		const { fallback, children } = this.props;
		if (hasError) {
			return fallback;
		}

		return children;
	}
}

export default ErrorBoundary;
